import React from 'react';
import classes from './looking-for-smth-different.scss';
export const LookingForSomethingDifferentComponent = ({
  isVisible,
  onClick
}) => {
  if (!isVisible) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.button,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, "Looking for something different?"));
};